import { action } from "satcheljs";
import type { ActionSource } from "owa-mail-store";
import type { MailboxInfo } from "owa-client-types";

/**
 * Closes reading pane from command bar
 */
export interface CloseImmersiveReadingPaneActionMessage {
    source: ActionSource | undefined;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (source?: ActionSource, mailboxInfo?: MailboxInfo) => CloseImmersiveReadingPaneActionMessage = action("closeImmersiveReadingPane", (source?: ActionSource, mailboxInfo?: MailboxInfo): CloseImmersiveReadingPaneActionMessage => {
    return {
        source,
        mailboxInfo,
    };
});
export default defaultExport;
